import { getLocale } from "../runtime";

const sv_gototest = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Gå till testsidan`
};

const gototest = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_gototest(inputs)
	return "goToTest";
};

export { gototest as "goToTest" };